<template>
  <Modal 
    :large="true"
    :exit="false"
  >
    <div slot="header">
      <div v-if="provincy" class="__form">
        <form >
          <div class="__header l-mb-3 l-pb-3">
            <h2 class>
              {{ selectedCity[0].stad }}
            </h2>
            <h3> De volgende beschrijving hebben wij geregistreerd voor {{selectedCity[0].stad}}</h3>
          </div>
          <div class="flex-row-full">
            <div class="l-mb-6">
              <div>
                {{ selectedCity[0].stadBeschrijving }}
              </div>
            </div>
          </div>
        </form>
      </div>

      <div v-if="!provincy" class="__form">
        <form >
          <div class="__header l-mb-3 l-pb-3">
            <h2 class>
              {{ selectedStreet[0].straat }}
            </h2>
            <h3> De volgende beschrijving hebben wij geregistreerd voor de  {{ selectedStreet[0].straat }}</h3>
          </div>
          <div class="flex-row-full">
            <div class="l-mb-6">
              <div>
                {{ selectedStreet[0].straatBeschrijving }}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div slot="footer">
      <div class="flex-row">
        <legend>
          Om deze service GRATIS te kunnen blijven aanbieden, wordt u doorgeleid naar een van onze partners.
        </legend>
        <a
          type="submit"
          class="btn-blue"
          @click.stop.prevent="submit"
        >
          Bedankt
        </a>
      </div>
    </div>
  </Modal>
</template>
<script>
import { mapState } from "vuex";
import Modal from "@/components/ComponentModal";
import axios from 'axios';

export default {
  name: "Dialog",
  components: {
    Modal
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    stadJson: {
      type: Object,
      required: false
    },
    starter: {
      type: String,
      required: true
    },
    provincy: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      stateModal: state => state.openModal,
      selectedCity() {
        return this.stadJson.filter(item => item.stad === this.starter); // Verwijder het specifieke element
      },
      selectedStreet() {
        return this.stadJson.filter(item => item.straat === this.starter); // Verwijder het specifieke element
      },
    })
  },
  mounted() {
    this.waitForLCP();
  },
  methods: {
    submit() {
      this.submitted = true;
      this.$store.dispatch("toggleModal", !this.stateModal);
      window.open('https://tc.tradetracker.net/?c=34975&m=2091628&a=480276&r=&u=', '_blank', 'width=800,height=600');
    },
    waitForLCP() {
      // Controleer eerst of PerformanceObserver beschikbaar is in de browser
      if ('PerformanceObserver' in window && 'largestContentfulPaint' in window.PerformanceObserver.supportedEntryTypes) {
        const observer = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          // LCP bereikt, trigger Vue.js-code
          if (entries.length > 0 && entries[entries.length - 1].entryType === 'largestContentfulPaint') {
            this.executeAfterLCP();
            observer.disconnect();  // Stop met het observeren zodra LCP is bereikt
          }
        });

        // Begin met het observeren van de LCP-gebeurtenis
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } else {
        // Als PerformanceObserver niet beschikbaar is, voer dan de code onmiddellijk uit
        this.fetchData();
      }
    },
    async fetchData() {
      this.loading = true; // Zet de loading status aan
      this.error = null;   // Reset eventuele eerdere fouten

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
        provincie: this.stadJson.provincy.charAt(0).toUpperCase() + this.stadJson.provincy.slice(1),
        stad: this.stadJson.city.charAt(0).toUpperCase() + this.stadJson.city.slice(1),
        straat: this.stadJson.street.charAt(0).toUpperCase() + this.stadJson.street.slice(1),
      };

      try {
        // Maak de API-aanroep
        const response = await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/stadStraat', {params});
        
        // Sla de opgehaalde data op in de component state
        this.basicStreetData = response.data['body-json'].body.parsedStraatData.straatBeschrijving;
        this.basicCityData = response.data['body-json'].body.parsedStadData.stadBeschrijving;
        
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<style>
.__header {
  border-bottom: 1px solid #e7e7e7;
}
.form-label {
  font-weight: 400;
  font-size: 16px;
}

@media screen and (min-width: 768px) {
  .__form {
    margin: 14px 0;
    padding: 20px 40px;
  }
  .__image img {
    max-width: 300px;
    margin-left: auto;
    height: auto;
  }
  .form-label {
    font-weight: 600;
    font-size: 20px;
  }
}

.flex-row-item {
  flex: 1 1 auto;
}

@media (min-width: 820px) {
  .form-input--small {
    width: 50%;
  }

}

</style>
